module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-19.58eaee40.svg";